
export type SiteShareAccessLevel = "audit" | "user" | "maintainer" | "owner";
export class SiteShareRecord {
    level: SiteShareAccessLevel = 'user';
    from: Date = null;
    until: Date = null;
    data: string
    /* JSON.stringify({
        controlOverrides: { 
            controlUuid: string,
            allowWrite: boolean,
            maxSpeed?: boolean,
            maxTemp?: boolean
        }[]
    })
    */
}

export class SiteRecord {
    id: number;
    uuid: string;
    userId: number;
    name: string;
    country: string;
    share?: SiteShareRecord;
    state: string;
    city: string;
    address: string;
    zip: string;
    latitude: number;
    longitude: number;
    version: string;
    versionName: string;
    monitored: number;
    maintainerId: number;
    maintainerLocationUuid: string;
    timezone?: string;

    constructor(data:Partial<SiteRecord>={}) {
        Object.assign(this, data);
    }
}